import moment from 'moment';

// @vue/component
export default {
    methods: {
        weekday(day) {
            return this.$t(`masterfiles.schedule.days.${day.toLowerCase()}`).slice(0, 2);
        },

        formatTime(time) {
            return moment(time, 'HH:mm:ss').format('HH:mm');
        },
    },
};
